import { Autocomplete, Stack, TextField } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { AutocompleteTagChip } from "./autocomplete-tag-chip"

export function ConditionValueRegimeOptions({ value, onChange, fieldConfig }) {
    const { regimeData } = useBoundContext()
    const dataKey = fieldConfig?.regimeDataKey
    const options = (regimeData && dataKey ? regimeData[dataKey] : null) || []
    const selected = Array.isArray(value) ? value : []

    return (
        <Autocomplete
            multiple
            freeSolo
            fullWidth
            options={options}
            value={selected}
            onChange={handleChange}
            renderInput={renderInput}
            renderTags={renderTags}
        />
    )

    function handleChange(_, newValue) {
        onChange(newValue)
    }

    function renderInput(params) {
        return (
            <TextField
                {...params}
                placeholder={selected.length === 0 ? `Select ${fieldConfig?.label || "values"}...` : ""}
            />
        )
    }

    function renderTags(tags, getTagProps) {
        return (
            <Stack direction="row" sx={{ flexWrap: "wrap", gap: 0.5 }}>
                <Repeat list={tags} item={<AutocompleteTagChip getTagProps={getTagProps} />} />
            </Stack>
        )
    }
}
